import type { InjectionKey } from "vue";

import type { ActionSource } from "@/model/action";

export const actionSourceKey: InjectionKey<ActionSource> = Symbol("actionSource");
